import { render } from "./widget-tariffs-main.vue?vue&type=template&id=dde66bf2&scoped=true"
import script from "./widget-tariffs-main.vue?vue&type=script&lang=js"
export * from "./widget-tariffs-main.vue?vue&type=script&lang=js"

import "./widget-tariffs-main.vue?vue&type=style&index=0&id=dde66bf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde66bf2"]])

export default __exports__